/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum SovrenOutputValidityCode {
  ovIsProbablyValid = "ovIsProbablyValid",
  ovProbableGarbageInText = "ovProbableGarbageInText",
  ovUnknown = "ovUnknown",
  ovAvgWordLengthGreaterThan20 = "ovAvgWordLengthGreaterThan20",
  ovAvgWordLengthLessThan4 = "ovAvgWordLengthLessThan4",
  ovTooFewLineBreaks = "ovTooFewLineBreaks",
  ovLinesSeemTooShort = "ovLinesSeemTooShort",
  ovTruncated = "ovTruncated",
  ovMayContainSomeReversedText = "ovMayContainSomeReversedText",
  ovConfigurationError = "ovConfigurationError",
  ovCorrupt = "ovCorrupt",
  ovCouldNotLoadFile = "ovCouldNotLoadFile",
  ovErrorOnOutputToHtml = "ovErrorOnOutputToHtml",
  ovErrorOnOutputToRtf = "ovErrorOnOutputToRtf",
  ovErrorOnOutputToText = "ovErrorOnOutputToText",
  ovErrorOnOutputToXml = "ovErrorOnOutputToXml",
  ovErrorOnOutputToPdf = "ovErrorOnOutputToPdf",
  ovFileNotFound = "ovFileNotFound",
  ovIsEncrypted = "ovIsEncrypted",
  ovIsImage = "ovIsImage",
  ovNullInput = "ovNullInput",
  ovTimeout = "ovTimeout",
  ovUnsupportedFormat = "ovUnsupportedFormat",
  ovWordConvErrorAndProbableProblems = "ovWordConvErrorAndProbableProblems",
  ovNoText = "ovNoText",
  UNMAPPED = "UNMAPPED",
}

export const SovrenOutputValidityCodeDisplay: Record<SovrenOutputValidityCode, string> = {
  [SovrenOutputValidityCode.ovIsProbablyValid]: "Ov Is Probably Valid",
  [SovrenOutputValidityCode.ovProbableGarbageInText]: "Ov Probable Garbage In Text",
  [SovrenOutputValidityCode.ovUnknown]: "Ov Unknown",
  [SovrenOutputValidityCode.ovAvgWordLengthGreaterThan20]: "Ov Avg Word Length Greater Than20",
  [SovrenOutputValidityCode.ovAvgWordLengthLessThan4]: "Ov Avg Word Length Less Than4",
  [SovrenOutputValidityCode.ovTooFewLineBreaks]: "Ov Too Few Line Breaks",
  [SovrenOutputValidityCode.ovLinesSeemTooShort]: "Ov Lines Seem Too Short",
  [SovrenOutputValidityCode.ovTruncated]: "Ov Truncated",
  [SovrenOutputValidityCode.ovMayContainSomeReversedText]: "Ov May Contain Some Reversed Text",
  [SovrenOutputValidityCode.ovConfigurationError]: "Ov Configuration Error",
  [SovrenOutputValidityCode.ovCorrupt]: "Ov Corrupt",
  [SovrenOutputValidityCode.ovCouldNotLoadFile]: "Ov Could Not Load File",
  [SovrenOutputValidityCode.ovErrorOnOutputToHtml]: "Ov Error On Output To Html",
  [SovrenOutputValidityCode.ovErrorOnOutputToRtf]: "Ov Error On Output To Rtf",
  [SovrenOutputValidityCode.ovErrorOnOutputToText]: "Ov Error On Output To Text",
  [SovrenOutputValidityCode.ovErrorOnOutputToXml]: "Ov Error On Output To Xml",
  [SovrenOutputValidityCode.ovErrorOnOutputToPdf]: "Ov Error On Output To Pdf",
  [SovrenOutputValidityCode.ovFileNotFound]: "Ov File Not Found",
  [SovrenOutputValidityCode.ovIsEncrypted]: "Ov Is Encrypted",
  [SovrenOutputValidityCode.ovIsImage]: "Ov Is Image",
  [SovrenOutputValidityCode.ovNullInput]: "Ov Null Input",
  [SovrenOutputValidityCode.ovTimeout]: "Ov Timeout",
  [SovrenOutputValidityCode.ovUnsupportedFormat]: "Ov Unsupported Format",
  [SovrenOutputValidityCode.ovWordConvErrorAndProbableProblems]: "Ov Word Conv Error & Probable Problems",
  [SovrenOutputValidityCode.ovNoText]: "Ov No Text",
  [SovrenOutputValidityCode.UNMAPPED]: "Unmapped",
};
